import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { RecentCommentModel } from '~types/recentComment';

interface UseGetRecentCommentResponse {
  data: RecentCommentModel[];
}

export function useGetRecentComment() {
  return useQuery<UseGetRecentCommentResponse>(['homeRecentComment'], () =>
    fetcher('/api/main/board'),
  );
}
